import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { menuItems } from './menuItems';
import MenuItems from './MenuItem';

const NavBar = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };
  const ref = useRef();
  useEffect(() => {
    const handler = (event) => {
      if (
        showNavbar &&
        ref.current &&
        !ref.current.contains(event.target)
      ) {
        setShowNavbar(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
    };
  }, [showNavbar]);
  return (
    <div>
      <nav className="nav-items" ref={ref} >
        <div className="logo">
          <NavLink to="/">
            <img src={'/feature/media/img/tokushu-media-logo.svg'} alt="tokushu-media-logo" />
          </NavLink>
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <img src={'/feature/media/img/hamburger.svg'} alt="hamburger-logo" />
        </div>
        <div className={`nav-elements ${showNavbar && 'active'}`}>
			<ul className="menu">
				{menuItems.map((menu, index) => {
				return <MenuItems items={menu} key={index} />;
				})}
			</ul>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
